import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';
import { NCZIExtension } from '../Interfaces/ncziTypes';

export type CancelDPNParams = PatientCommandParams & {
	confirmation: {
		previousVersion: NCZIExtension;
		versionSetId: NCZIExtension | undefined;
		sensitivity: number;
		uncertaintyExpressed: boolean;
		createdAt: string;
		versionStatus: string;
		reason: string;
	};
};

export const CancelDPN = (params: CancelDPNParams): Command => {
	return {
		operation: 'StornujPotvrdenieDPN_v1',
		params,
	};
};
